"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Main = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var structure_1 = require("remota-client/component/structure");
var panel_1 = require("remota-client/component/panel");
var button_1 = require("remota-client/component/button");
var icon_1 = require("remota-client/component/icon");
var Main = function () {
    var tenantId = (0, react_router_dom_1.useParams)().tenantId;
    return (react_1.default.createElement(structure_1.PlainStructure, { center: true },
        react_1.default.createElement(panel_1.LogoPanel, { width: 300 },
            react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(button_1.IconButton, { icon: icon_1.person, href: "/auth/sso/saml/callback/".concat(tenantId) }, "SSO \u3067\u30ED\u30B0\u30A4\u30F3")))));
};
exports.Main = Main;
